import { useQuery } from '@tanstack/react-query';

import { dialogsEndpoints as endpoints } from '@/api/endpoints';
import { API } from '@/hooks/useDialogs';
import { Dialogs } from '@/shared/types/dialog';

export type StartingNode = {
  dialogId: string;
  dialogName: string;
  nodeName: string;
  nodeType: string;
};

const STALE_TIME = 5 * 60 * 1000;

export const useStartingNode = (brainId: string, nodeId?: string | null) =>
  useQuery<Dialogs, Error, StartingNode | null>({
    queryKey: [endpoints.dialogs(brainId)],
    queryFn: () => API.listDialogs(brainId),
    enabled: !!brainId && !!nodeId,
    staleTime: STALE_TIME,
    refetchOnWindowFocus: false,
    select: (data) => {
      for (const dialog of data?.dialogs ?? []) {
        const node = dialog.nodes?.find((n) => n.node_id === nodeId);
        if (node) {
          return {
            dialogId: dialog.dialog_id,
            dialogName: dialog.name,
            nodeName: node.name,
            nodeType: node.type,
          };
        }
      }
      return null;
    },
  });
